import { addMultipleEventListener } from '../Tools';

interface IWeatherTab {
    tab: HTMLElement;
    infoDiv: HTMLDivElement;
    slider: HTMLElement;
    JQSlider?: JQuery;
    ruler?: HTMLElement;
    playStop?: HTMLElement;
    back?: HTMLElement;
    forward?: HTMLElement;
    active: boolean;
    currentImage?: HTMLElement;
    imageIndex?: number;
    imageContainer?: NodeListOf<HTMLElement>;
    isStopped: boolean;
    imagesReady: boolean;
    height: number;
}
interface ILayerImage extends HTMLImageElement {
    realWidth?: number;
    realHeight?: number;
}
enum EDirection {
    forward = 1,
    back = -1
}
export default class WeatherTabs {
    protected container: NodeListOf<HTMLElement>;
    protected tabs: Array<IWeatherTab> = new Array();
    protected interval = 2 * 1000;
    protected handle = null;
    protected layer: HTMLElement;
    protected layerContent: HTMLElement;
    protected layerImage: ILayerImage;
    protected layerImageMargin = 50;

    constructor() {
        const _this = this;
        if (document.querySelectorAll('.edit-validator.weather-tabs').length) {
            window.addEventListener('cms-save', (ev: CustomEvent) => _this.validate(ev), false);
            return;
        }

        this.container = document.querySelectorAll('.tabs.lazy-diashow');
        if (!this.container.length) {
            return;
        }

        this.initLayer();
        this.container.forEach((container) => this.initTabs(container));

    }

    /**
     * Layer initialisieren
     */
    initLayer() {
        const _this = this;
        this.layer = document.querySelector('.overlay');
        if (!this.layer) {
            this.layer = document.createElement('div');
            this.layer.classList.add('hidden');
            this.layer.classList.add('overlay');
            this.layer.innerHTML = '<div class="centered"><div class="inner"></div></div>';
            document.body.insertAdjacentElement('beforeend', this.layer);
            this.layerContent = this.layer.querySelector('.inner');
        }
        document.addEventListener('keydown', (ev) => {
            if (ev.key === 'Escape') {
                _this.animateClose();
            }
        });

        addMultipleEventListener(this.layer, ['click', 'touch'], () => {
            _this.animateClose();
        });
    }

    async animateClose() {
        const _this = this;
        const duration = 300;
        // set start values for animate
        _this.layerContent.style.transform = `scale(1)`;
        _this.layer.style.opacity = '1';

        // scale image
        _this.layerContent
            .animate([{ transform: 'scale(0)' }], {
                duration: duration
            })
            .addEventListener('finish', () => { });
        // opacity for layer
        _this.layer
            .animate([{ opacity: 0 }], {
                duration: duration
            })
            .addEventListener('finish', () => {
                _this.layer.classList.add('hidden');
                _this.layer.style.opacity = '';
                _this.layerContent.style.transform = '';
            });
    }

    /**
     * Validator beim speichern im Backend
     * @param ev CustomEvent
     */
    validate(ev: CustomEvent) {
        const cmsElements: NodeListOf<HTMLElement> = ev.detail.zone;
        let valid = true;
        cmsElements.forEach((el) => {
            if (el.querySelectorAll('.edit-validator.weather-tabs').length) {
                el.querySelectorAll('input[type=checkbox]').forEach(
                    (checkbox: HTMLInputElement, index) => {
                        if (checkbox.checked) {
                            const tabInput: HTMLInputElement = <HTMLInputElement>(
                                checkbox.closest('.row').querySelectorAll('input[type=text]')[0]
                            );
                            if (tabInput.value.trim().length === 0) {
                                valid = false;
                            }
                        }
                    }
                );
            }
        });
        if (!valid) {
            ev.preventDefault();
            alert('Gewählte Pfade benötigen eine Überschrift für den Reiter');
        }
    }

    initTabs(container: HTMLElement) {
        const _this = this;
        if (!container.querySelectorAll('.tab-header').length) {
            return;
        }
        container.querySelectorAll('.tab-header').forEach((el: HTMLElement, index: number) => {
            _this.tabs.push({
                tab: el,
                infoDiv: <HTMLDivElement>el.parentElement.querySelectorAll('div.infoText')[index],
                slider: el.nextElementSibling.querySelector('.slider-options-outer'),
                active: false,
                imageIndex: 0,
                imageContainer: el.nextElementSibling.querySelectorAll('.item'),
                isStopped: false,
                imagesReady: false,
                height: 0
            });
        });
        _this.tabs.forEach((tabContainer: IWeatherTab) => {
            tabContainer.tab.style.width = Math.floor(100 / _this.tabs.length) + '%';
            tabContainer.tab.addEventListener('click', () => {
                _this.changeTab(tabContainer);
            });
            _this.initSlider(tabContainer);
            if (tabContainer.tab.classList.contains('active')) {
                tabContainer.active = true;
                _this.loadImages(tabContainer);
                _this.slideTabImages(tabContainer);
            }
        });
        if (_this.tabs.length === 1) {
            _this.tabs[0].tab.classList.add('hidden');
        }
        this.changeTab(this.tabs[0]);
        window.addEventListener('resize', () => _this.evWindowResize());
    }

    evWindowResize() {
        const _this = this;
        let newHeight = 0;

        this.tabs.forEach((tab) => {
            if (tab.active) {
                const infoHeight = tab.infoDiv.offsetHeight;
                tab.imageContainer.forEach((c) => {
                    const imageHeight = c.querySelector('img').offsetHeight;
                    if (imageHeight > newHeight) {
                        newHeight = imageHeight + infoHeight;
                    }
                });

                (<HTMLElement>tab.tab.nextElementSibling).style.height =
                    newHeight + tab.slider.offsetHeight + 'px';
            }
        });
        if (!_this.layer.classList.contains('hidden')) {
            _this.layerResize();
        }
    }

    layerResize() {
        const _this = this;
        const margin = _this.layerImageMargin;
        let maxWidth = _this.layerImage.realWidth;
        let maxHeight = _this.layerImage.realHeight;
        let maxTries = 4000;
        while (
            maxTries > 0 &&
            (maxWidth + margin > window.innerWidth || maxHeight + margin > window.innerHeight)
        ) {
            maxWidth--;
            maxHeight--;
            maxTries--;
        }
        _this.layerContent.style.width = maxWidth + 'px';
        _this.layerContent.style.height = maxHeight + 'px';
    }

    evPause(tabContainer: IWeatherTab) {
        tabContainer.active = false;
        tabContainer.playStop.innerHTML = '<i class="icon-play"></i> Start';
        tabContainer.back.style.display = '';
        tabContainer.forward.style.display = '';
    }

    evStart(tabContainer: IWeatherTab) {
        tabContainer.active = true;
        tabContainer.playStop.innerHTML = '<i class="icon-pause"></i> Pause';
        tabContainer.back.style.display = 'none';
        tabContainer.forward.style.display = 'none';
        this.changeImage(tabContainer);
    }

    initSlider(tabContainer: IWeatherTab) {
        const _this = this;
        tabContainer.playStop = tabContainer.slider.querySelector('.playpause');
        tabContainer.back = tabContainer.slider.querySelector('.btn-back');
        tabContainer.forward = tabContainer.slider.querySelector('.btn-forward');

        tabContainer.back.addEventListener('click', () => {
            _this.changeImage(tabContainer, EDirection.back);
        });
        tabContainer.forward.addEventListener('click', () => {
            _this.changeImage(tabContainer, EDirection.forward);
        });

        tabContainer.JQSlider = $(tabContainer.slider.querySelector('.slider-horizontal')).slider({
            orientation: 'horizontal',
            range: 'min',
            min: 0,
            max: tabContainer.imageContainer.length - 1,
            value: 0,
            slide: function (event, ui) {
                _this.evPause(tabContainer);
                tabContainer.currentImage.classList.remove('opacity-1');
                tabContainer.currentImage.classList.add('opacity-0');
                tabContainer.currentImage = tabContainer.imageContainer[ui.value];
                tabContainer.currentImage.classList.remove('opacity-0');
                tabContainer.currentImage.classList.add('opacity-1');
            }
        });

        tabContainer.playStop.addEventListener('click', (ev) => {
            if (tabContainer.active) {
                tabContainer.isStopped = true;
                _this.evPause(tabContainer);
            } else {
                tabContainer.isStopped = false;
                _this.evStart(tabContainer);
            }
        });
    }

    changeTab(tabContainer: IWeatherTab) {
        const _this = this;
        _this.tabs.forEach((tab) => {
            if (tab.active || tab.tab.classList.contains('active')) {
                _this.evPause(tab);
                tab.tab.classList.remove('active');
                tab.tab.nextElementSibling.classList.remove('active');
            }
        });
        tabContainer.tab.classList.add('active');
        let imagesContainer = <HTMLElement>tabContainer.tab.nextElementSibling;
        imagesContainer.classList.add('active');
        if (imagesContainer.querySelectorAll('.loader').length) {
            _this.loadImages(tabContainer);
        }
        if (!tabContainer.isStopped) {
            _this.evStart(tabContainer);
        }
        const slider: HTMLElement = imagesContainer.querySelector('.slider-options-outer');
        tabContainer.tab.parentElement.style.height = tabContainer.height + 'px';
    }

    loadImages(tabContainer: IWeatherTab) {
        const _this = this;
        const imagesContainer = <HTMLElement>tabContainer.tab.nextElementSibling;
        const tabHeader: HTMLDivElement = (<HTMLDivElement>imagesContainer.closest('.tabs.lazy-diashow')).querySelector('.tab-header');
        const slider: HTMLElement = imagesContainer.querySelector('.slider-options-outer');
        let height = 0;
        tabContainer.currentImage = imagesContainer.querySelector('.item.opacity-1');
        tabContainer.height = (tabHeader.offsetHeight + 4) + slider.offsetHeight;

        let countLoaded = 0;
        tabContainer.imageContainer.forEach((imgContainer: HTMLElement) => {
            let image = new Image();
            imagesContainer.style.height = height + slider.offsetHeight + 'px';
            image.alt = '';
            image.addEventListener('load', () => {
                const infoHeight = tabContainer.infoDiv.offsetHeight;
                imgContainer.querySelector('img').remove();
                imgContainer.insertAdjacentElement('afterbegin', image);
                countLoaded++;
                if (image.height > height - infoHeight) {
                    height = image.height + infoHeight;

                    imagesContainer.style.height = height + slider.offsetHeight + 'px';

                    tabContainer.height = (tabHeader.offsetHeight + 4) + height + slider.offsetHeight;
                    (<HTMLDivElement>imagesContainer.closest('.tabs.lazy-diashow')).style.height = tabContainer.height + 'px';
                }
                if (countLoaded === tabContainer.imageContainer.length) {
                    tabContainer.imagesReady = true;
                }
            });
            image.src = imgContainer.dataset.lazy;
            if (imgContainer.dataset.zoom) {
                image.addEventListener('click', (ev) => {
                    ev.preventDefault();
                    _this.evPause(tabContainer);
                    _this.layerImage = new Image();
                    const layerLoader = new Image();
                    layerLoader.src = '/img/loader.gif';
                    layerLoader.alt = 'Lade...';
                    layerLoader.classList.add('opacity-1');

                    _this.layerImage.classList.add('opacity-0');
                    _this.layerImage.alt = 'Zoom';
                    _this.layerImage.addEventListener('load', () => {
                        _this.layerImage.realHeight = _this.layerImage.height;
                        _this.layerImage.realWidth = _this.layerImage.width;
                        _this.layerContent.insertAdjacentElement('beforeend', _this.layerImage);
                        layerLoader.classList.remove('opacity-1');
                        layerLoader.classList.add('opacity-0');
                        _this.layerImage.classList.remove('opacity-0');
                        _this.layerImage.classList.add('opacity-1');
                        _this.layerResize();
                    });
                    _this.layerImage.src = imgContainer.dataset.zoom;
                    _this.layerContent.style.width = layerLoader.width + 'px';
                    _this.layerContent.style.height = layerLoader.height + 'px';

                    _this.layerContent.innerHTML =
                        '<div class="circle"><i class="icon-cancel"></i></div>';
                    _this.layerContent.insertAdjacentElement('beforeend', layerLoader);
                    _this.layer.classList.remove('hidden');
                    tabContainer.isStopped = true;
                });
            }
        });

    }

    slideTabImages(tabContainer: IWeatherTab) {
        const _this = this;
        if (_this.handle) {
            window.clearTimeout(_this.handle);
        }
        _this.handle = window.setTimeout(() => {
            _this.changeImage(tabContainer);
            _this.handle = null;
        }, _this.interval);

    }

    changeImage(currentTab: IWeatherTab, direction?: EDirection) {
        const _this = this;
        if (currentTab.currentImage && (currentTab.active || direction)) {
            currentTab.currentImage.classList.remove('opacity-1');
            currentTab.currentImage.classList.add('opacity-0');
            let nextImageContainer = <HTMLElement>currentTab.currentImage.nextElementSibling;
            if (direction && direction === EDirection.back) {
                nextImageContainer = <HTMLElement>currentTab.currentImage.previousElementSibling;
                if (!nextImageContainer) {
                    nextImageContainer =
                        currentTab.currentImage.parentElement.querySelector('.item:last-child');
                }
            }

            if (!nextImageContainer || !nextImageContainer.classList.contains('item')) {
                nextImageContainer = currentTab.currentImage.parentElement.querySelector('.item');
            }
            nextImageContainer.classList.remove('opacity-0');
            nextImageContainer.classList.add('opacity-1');
            currentTab.currentImage = nextImageContainer;

            currentTab.imageContainer.forEach((imageContainer, index) => {
                if (imageContainer.classList.contains('opacity-1')) {
                    currentTab.imageIndex = index;
                    return false;
                }
            });
            currentTab.JQSlider.slider('value', currentTab.imageIndex);
            _this.slideTabImages(currentTab);
        }
    }
}
